import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ForgotPasswordForm,
  ResendResetPasswordEmail,
  TForgotPasswordData,
} from '@/features/auth';
import { Box } from '@/shared/ui';
import { Logo } from '@/shared/ui/Logo';
import { RouterLink } from '@/shared/ui/RouterLink';
import { getRoutePath } from '@/shared/utils/routes';

import { StyledBox } from './styles';

export const ForgotPassword = () => {
  const { t } = useTranslation();

  const [isMailSent, setIsMailSent] = useState(false);
  const [emailSent, setEmailSent] = useState('');

  return (
    <StyledBox>
      <Logo />
      {isMailSent ? (
        <ResendResetPasswordEmail email={emailSent} />
      ) : (
        <ForgotPasswordForm
          onSubmited={({ email }: TForgotPasswordData) => {
            setEmailSent(email);
            setIsMailSent(true);
          }}
        />
      )}

      <Box mt={3}>
        <RouterLink
          to={getRoutePath('AUTH', 'LOGIN')}
          underline="hover"
          variant="body2"
        >
          {t('auth:common:backToLogin')}
        </RouterLink>
      </Box>
    </StyledBox>
  );
};
